export enum documentTypes {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
  RICHDOCUMENT = 'richdocument',
  NOTE = 'note',
}
